// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2lrqT","item":"styles_item__1pail","rectangle":"styles_rectangle__1xzqz"};